























































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {ColumnType, CommonModelUtils, PageInfo, TableHeader} from '@/model/CommonModel';
import FilterFacade from '@/components/table/filter/FilterFacade.vue';

@Component({
  components: {FilterFacade}
})
export default class CommonPaginatedTable extends Vue {
  @Prop({default: ''}) private readonly id: string;
  @Prop({default: ''}) private readonly menuId: string;
  @Prop({default: () => []}) private readonly columns: TableHeader[];
  @Prop({default: () => []}) private readonly values: any[];
  @Prop({
    default: () => {
      return {
        menuId: '',
        pageNo: 0,
        rowCount: 0,
        totalCount: 0,
        totalPage: 0
      };
    }
  })
  private readonly pageInfo: PageInfo;

  @Prop({default: true}) private readonly showPagination: boolean;
  @Prop({default: true}) private readonly numbering: boolean;
  @Prop({default: 'desc'}) private readonly numberingSort: string;
  @Prop({default: true}) private readonly loading: boolean;
  @Prop({default: ''}) protected readonly tableBodyHeight: string;
  @Prop({default: ''}) private readonly tableBodyMaxHeight: string;
  @Prop({default: ''}) protected readonly colgroupSumWidth: string;
  @Prop({
    default: () => {
      return (row: any) => {
        return {};
      };
    }
  }) private readonly rowClassSupplier: (row: any) => any;
  @Prop({
    default: () => {
      return {};
    }
  }) private readonly tableClass: any;
  @Prop({
    default: () => {
      return [10, 15, 20, 25, 30, 50, 100];
    }
  })
  private readonly rowSizes: number[];

  @Prop({default: 0}) private readonly columnLength: number;
  @Prop({default: () => []}) protected readonly columnClickableIds: any;

  get componentId() {
    return this.id ? this.id : `common-paginated-table-${Math.floor(Math.random() * 1000000)}`;
  }

  get renderableColumns() {
    return this.columns.filter(column => CommonModelUtils.isRenderableTableHeader(column));
  }

  get supplyPagination() {
    return this.showPagination && this.values && this.values.length > 0;
  }

  get supplyNumbering() {
    return this.numbering;
  }

  get isAscNumberingSorting() {
    return this.numberingSort === 'asc';
  }

  get isLoading() {
    return this.loading;
  }

  get getRowSizes() {
    return this.rowSizes;
  }

  get getMenuId() {
    return this.menuId;
  }

  get headerClass() {
    return (header: TableHeader) => {
      return {
        'filtered': header.filtered === 'Y'
      };
    };
  }

  get getEmptyColspanSize() {
    return this.columnLength ? this.columnLength
        : this.supplyNumbering ? this.renderableColumns.length + 1 : this.renderableColumns.length;
  }


  get getTableBodyWrapStyle() {
    return {
      height: this.getTableBodyHeight,
      minWidth: this.colgroupSumWidth,
      maxHeight: this.tableBodyMaxHeight,
    };
  }

  get getTableBodyHeight() {
    return this.tableBodyHeight;
  }

  get getRowClassSupplier() {
    return (row: any) => {
      return this.rowClassSupplier(row);
    };
  }

  get colgroupWidth() {
    return {minWidth: this.colgroupSumWidth};
  }

  get tableClasses() {
    if (this.tableClass === 'auditTrail') {
      return {
        'unfull-text': false,
        ...this.tableClass
      };
    }

    return {
      'unfull-text': !this.$store.getters.fullTextActivated,
      ...this.tableClass
    };
  }

  get getNumbering() {
    return this.numbering;
  }

  get getColumnLength() {
    return this.columnLength;
  }

  get linkableClass() {
    return (columnId: string, addedClass: string = '') => {
      return this.columnClickableIds.includes(columnId) ? `${addedClass} td-link` : `${addedClass}`;
    };
  }

  public mounted() {
    this.$nextTick(() => {
      const $viewWrap = document.getElementsByClassName('tab-inner-router-view-wrap')[0];
      if (!$viewWrap || !($viewWrap instanceof HTMLElement) || !$viewWrap.offsetHeight) {
        return {};
      }

      const $paginateWrap = document.getElementsByClassName('el-pagination')[0];
      const $header = document.getElementsByClassName('el-table__header-wrapper')[0];

      const margin = $paginateWrap
          ? (parseInt(getComputedStyle($paginateWrap).marginTop, 10)
              + parseInt(getComputedStyle($paginateWrap).marginBottom, 10))
          : 0;

      const height = $viewWrap.offsetHeight
          - ($paginateWrap && $paginateWrap instanceof HTMLElement ? $paginateWrap.offsetHeight : 0)
          - ($header && $header instanceof HTMLElement ? $header.offsetHeight : 0) - margin;

      this.$emit('heightCalculated', `${height}px`);
    });
  }

  public getNo(index: number) {
    if (this.isAscNumberingSorting) {
      return ((this.pageInfo.pageNo - 1) * this.pageInfo.rowCount) + (index + 1);
    } else {
      return this.pageInfo.totalCount - ((this.pageInfo.pageNo - 1) * this.pageInfo.rowCount) - index;
    }
  }

  public isHTMLColumnType(columnType: ColumnType) {
    return columnType === ColumnType.HTML;
  }

  public onTableRowClick(value: any, $event: any) {
    this.$emit('rowClick', {
      row: value,
      $event
    });
  }

  public onTableColumnClick(value: any, columnId: string, $event: Event) {
    this.$emit('columnClick', {row: value, columnId, $event});
  }

  public onPageNoChange(pageNo: number) {
    this.emitNavigate(pageNo, this.pageInfo.innerRowCount ? this.pageInfo.innerRowCount : this.pageInfo.rowCount);
  }

  public onPageSizeChange(pageSize: number) {
    this.pageInfo.innerRowCount = pageSize;
    const pageNo = +this.$route.params.pageNo;
    this.onPageNoChange(pageNo ? pageNo : this.pageInfo.pageNo);
  }

  public onRefresh() {
    this.$emit('refresh');
  }

  private emitNavigate(pageNo: number, rowCount: number) {
    if ((pageNo - 1) * rowCount < this.pageInfo.totalCount) {
      this.$emit('navigate', {
        pageNo,
        rowCount
      });
    } else {
      console.log(pageNo, rowCount, this.pageInfo.totalCount, ' was blocked');
    }
  }
}
